// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"100":"e1cea0c6","990":"e8931867"}[chunkId] + ".chunk.css";
};